var UsersModule = /** @class */ (function () {
    function UsersModule() {
    }
    return UsersModule;
}());
export { UsersModule };
